// extracted by mini-css-extract-plugin
export default {"title":"SkillCommandToggle_title__WMfXG","root":"SkillCommandToggle_root__WIgrO","highlight":"SkillCommandToggle_highlight__chceG"};